import React from "react";
import "./index.css";

const QuantityWithUnit = ({
  value,
  onChange,
  units = [],
  placeholder = "0",
  defaultUnit = "L",
  disabled = false,
}) => {
  // Parse the current value - it could be an object with qty and unit, or just a number
  const currentQty =
    value?.qty !== undefined
      ? value.qty
      : (typeof value === "object" ? value.value : value) || "";
  const currentUnit = value?.qty_unit || value?.unit || defaultUnit;

  const handleQtyChange = (newQty) => {
    onChange({
      qty: newQty,
      qty_unit: currentUnit,
    });
  };

  const handleUnitChange = (newUnit) => {
    onChange({
      qty: currentQty,
      qty_unit: newUnit,
    });
  };

  return (
    <div className="quantity-with-unit">
      <input
        type="number"
        value={currentQty}
        onChange={(e) => handleQtyChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className="quantity-input"
      />
      <select
        value={currentUnit}
        onChange={(e) => handleUnitChange(e.target.value)}
        disabled={disabled}
        className="unit-dropdown"
      >
        {units.map((unit) => (
          <option key={unit.value} value={unit.value}>
            {unit.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default QuantityWithUnit;

